export const premiumCalendarEndpoints = (builder) => ({
  getPremiumCalendarReport: builder.query({
    query: (params = {}) => ({
      url: '/policy-management/generate-premium-calendar-report',
      method: 'GET',
      params,
    }),
    transformResponse: (response) => ({
      data: response?.data ?? [],
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: (result) => [{ type: 'PremiumCalendar', id: 'LIST' }],
  }),

  previewPremiumCalendarReport: builder.query({
    query: (params = {}) => ({
      url: '/policy-management/preview-premium-calendar-report',
      method: 'GET',
      params,
    }),
    transformResponse: (response) => response,
    providesTags: (result, error, arg) => [{ type: 'PremiumCalendar', id: 'PREVIEW' }],
  }),
});
